import type { GetJobDetails_jobDetails as JobDetails } from 'src/modules/graphql/queries/types/GetJobDetails';
import type { GetJobDetailsPersonalised_jobDetails as JobDetailsPersonalised } from 'src/modules/graphql/queries/types/GetJobDetailsPersonalised';
import { brandedJobs } from './brandedJobs';
import { minEnrichedJob } from './minEnrichedJob';
import { MockRateLimitedGraphQLError } from '../utils/mockErrors';

const jobIDsIsSaved: Record<string, boolean> = {
  '29663971': true,
  '29663948': true,
};

export const jobDetailsMock: Record<string, any> = {
  '29677777': {
    appliedDateTime: '21 September 2022',
    advertiser: {
      id: '20730726',
      name: 'Department of Justice and Regulation',
    },
    classification: {
      id: '6058',
      description: 'Mining, Resources & Energy',
    },
    subClassification: {
      id: '6075',
      description: 'Other',
    },
    locationInfo: {
      area: '',
      location: 'Melbourne',
      locationIds: ['18578'],
    },
    hasRoleRequirements: false,
    adProductType: 'Premium',
    title: 'Prison Officer - Metropolitan Remand Centre',
    isPrivateAdvertiser: false,
    isLinkOut: false,
    isVerified: true,
    listingDate: '10d ago',
    workType: 'Casual/Vacation',
    workTypeIds: '245',
    salary: '',
    status: 'Active',
    video: {
      url: 'https://www.youtube.com/embed/7ZdyRlMSmPk',
      position: 'TOP',
    },
    companySearchUrl:
      '/Department-of-Justice-&-Regulation-VIC-jobs/at-this-company',
    companyReviews: {
      id: 123,
      rating: 3.4,
      reviewCount: 86,
      reviewsUrl: '/companies/macquarie-group-432455/reviews?jobId=32861690',
      fullName: 'Macquarie Group',
    },
    companyTags: [
      { key: 'Registration No.', value: '20153489G' },
      { key: 'EA No.', value: '150-LB-090120-R' },
    ],
    content:
      "<p>Global Industrial has been a leader in the industrial racking &amp; industrial supply industry for the last 40 years. We are currently seeking an experienced warehousing team member for a casual position at our latest Sydney warehouse based in our facility in Prestons, with a view to the position becoming permanent full time depending upon the applicant.</p>  <p> </p>  <p><strong>ESSENTIAL JOB FUNCTIONS</strong></p> <ul> <li>Daily liaison with Supervisor for jobs allocation and reporting</li> <li>Picking and packing of orders in a busy small team</li> <li>Accurate packaging of orders</li> <li>Assembly of product and some fabrication work</li> <li>A willingness to attend to general warehousing and house-keeping duties</li> <li>Experience in unloading shipping containers, however training will be provided to suitable applicants</li> <li>Proactive approach to OH&amp;S in the warehouse environment</li> <li>Other duties as required</li></ul> <p><strong>REQUIREMENTS</strong></p> <ul> <li>Previous warehousing experience</li> <li>Previous experience with racking and shelving systems would be an advantage.</li> <li>Attention to detail</li> <li>Ability to work under pressure and meet deadlines</li> <li>Current forklift license</li> <li>Mature outlook</li> <li>Excellent communication &amp; interpersonal skills</li> <li>Good time management skills</li> <li>Fresh ideas to help our organisations continued growth</li> <li>National police certificate</li> <li>Right to work in Australia</li></ul> <p> </p>  <p>This position's normal operating hours are Monday to Friday 8am to 4.30pm.</p>  <p>We offer a fun and challenging work environment with great teammates.</p>  <p>Suitably qualified and skilled candidates are encouraged to forward their resume and cover letter via the Apply for this job button below.</p>  <p>Applicants must have the legal right to work in Australia </p>  <p> </p>  <p>General Manager (Eastern States)</p><p>If you are interested in this new opportunity, please contact <strong>Amy Hatfield</strong> at Fuse Recruitment on <strong>test@example.com</strong> or <strong>0111 211 311</strong><strong> </strong>for a confidential discussion or apply now.</p>",
    contactMatches: [
      {
        type: 'Email',
        value: 'test@example.com',
        __typename: 'ContactMatches',
      },
      {
        type: 'Phone',
        value: '0111 211 311',
        __typename: 'ContactMatches',
      },
    ],
    sourcr: {
      image:
        'https://media.sourcr.com/seek/f11h67fxeq/amy-hatfield-1-21a296b091.jpeg',
      imageMobile:
        'https://media.sourcr.com/seek/f11h67fxeq/mobile-amy-hatfield-1-21a296b091.jpeg',
      link: 'https://www.sourcr.com/recruiter/amy-hatfield-1?utm_source=Seek&utm_medium=978&utm_campaign=amy-hatfield-1',
    },
  },
  '29752529': {
    topApplicantBadge: {
      label: 'You may be a strong applicant',
      description:
        'Using data based on employers’ past behaviour, the default resumé in your profile and other factors, SEEK predicts you may be a strong applicant for this role.',
    },
    advertiser: {
      id: '20918739',
      name: 'Charterhouse Professional Support',
      searchParams: {
        advertiserid: 20918739,
      },
    },
    classification: {
      id: '6251',
      description: 'Administration & Office Support',
    },
    subClassification: {
      id: '6257',
      description: 'PA, EA & Secretarial',
    },
    locationInfo: {
      area: '',
      location: 'Sydney',
      locationIds: ['16351'],
    },
    hasRoleRequirements: true,
    adProductType: 'Premium',
    title: 'Senior EA/Business Manager $110,000 package',
    isPrivateAdvertiser: false,
    isLinkOut: true,
    isVerified: true,
    listingDate: '1d ago',
    workType: 'Full Time',
    workTypeIds: '242',
    salary: '$110,000 package',
    status: 'Active',
    video: {
      url: 'https://www.youtube.com/embed/7ZdyRlMSmPk',
      position: 'BOTTOM',
    },
    restrictedApplication: {
      canApply: false,
      label:
        'This role is located outside the Philippines. You cannot apply because it does not meet POEA requirements.',
    },
    companyReviews: null,
    content:
      "<p>Global Industrial has been a leader in the industrial racking &amp; industrial supply industry for the last 40 years. We are currently seeking an experienced warehousing team member for a casual position at our latest Sydney warehouse based in our facility in Prestons, with a view to the position becoming permanent full time depending upon the applicant.</p>  <p> </p>  <p><strong>ESSENTIAL JOB FUNCTIONS</strong></p> <ul> <li>Daily liaison with Supervisor for jobs allocation and reporting</li> <li>Picking and packing of orders in a busy small team</li> <li>Accurate packaging of orders</li> <li>Assembly of product and some fabrication work</li> <li>A willingness to attend to general warehousing and house-keeping duties</li> <li>Experience in unloading shipping containers, however training will be provided to suitable applicants</li> <li>Proactive approach to OH&amp;S in the warehouse environment</li> <li>Other duties as required</li></ul> <p><strong>REQUIREMENTS</strong></p> <ul> <li>Previous warehousing experience</li> <li>Previous experience with racking and shelving systems would be an advantage.</li> <li>Attention to detail</li> <li>Ability to work under pressure and meet deadlines</li> <li>Current forklift license</li> <li>Mature outlook</li> <li>Excellent communication &amp; interpersonal skills</li> <li>Good time management skills</li> <li>Fresh ideas to help our organisations continued growth</li> <li>National police certificate</li> <li>Right to work in Australia</li></ul> <p> </p>  <p>This position's normal operating hours are Monday to Friday 8am to 4.30pm.</p>  <p>We offer a fun and challenging work environment with great teammates.</p>  <p>Suitably qualified and skilled candidates are encouraged to forward their resume and cover letter via the Apply for this job button below.</p>  <p>Applicants must have the legal right to work in Australia </p>  <p> </p>  <p>General Manager (Eastern States)</p><p>If you are interested in this new opportunity, please contact <strong>Amy Hatfield</strong> at Fuse Recruitment on <strong>test@example.com</strong> or <strong>0111 211 311</strong><strong> </strong>for a confidential discussion or apply now.</p>",
    contactMatches: [
      {
        type: 'Email',
        value: 'test@example.com',
        __typename: 'ContactMatches',
      },
      {
        type: 'Phone',
        value: '0111 211 311',
        __typename: 'ContactMatches',
      },
    ],
    sourcr: {
      image:
        'https://media.sourcr.com/seek/f11h67fxeq/amy-hatfield-1-21a296b091.jpeg',
      imageMobile:
        'https://media.sourcr.com/seek/f11h67fxeq/mobile-amy-hatfield-1-21a296b091.jpeg',
      link: 'https://www.sourcr.com/recruiter/amy-hatfield-1?utm_source=Seek&utm_medium=978&utm_campaign=amy-hatfield-1',
    },
  },
  '29663971': {
    advertiser: {
      id: '23772496',
      name: 'Maha',
    },
    classification: {
      id: '1212',
      description: 'Hospitality & Tourism',
    },
    subClassification: {
      id: '1549',
      description: 'Waiting Staff',
    },
    locationInfo: {
      area: 'CBD & Inner Suburbs',
      location: 'Melbourne',
      locationIds: ['18578'],
    },
    hasRoleRequirements: true,
    adProductType: 'Premium',
    title: 'Front of House Waitstaff',
    isPrivateAdvertiser: false,
    isLinkOut: true,
    isVerified: true,
    listingDate: '20d ago',
    workType: 'Full Time',
    workTypeIds: '242',
    salary: '',
    status: 'Active',
    video: {
      url: 'https://www.youtube.com/embed/7ZdyRlMSmPk',
      position: 'TOP',
    },
    companySearchUrl: '/Macquarie-Group-jobs/at-this-company',
    companyReviews: {
      id: 123,
      rating: 3.4,
      reviewCount: 86,
      reviewsUrl: '/companies/macquarie-group-432455/reviews?jobId=32861690',
      fullName: 'Macquarie Group',
    },
    content:
      "<p>Global Industrial has been a leader in the industrial racking &amp; industrial supply industry for the last 40 years. We are currently seeking an experienced warehousing team member for a casual position at our latest Sydney warehouse based in our facility in Prestons, with a view to the position becoming permanent full time depending upon the applicant.</p>  <p> </p>  <p><strong>ESSENTIAL JOB FUNCTIONS</strong></p> <ul> <li>Daily liaison with Supervisor for jobs allocation and reporting</li> <li>Picking and packing of orders in a busy small team</li> <li>Accurate packaging of orders</li> <li>Assembly of product and some fabrication work</li> <li>A willingness to attend to general warehousing and house-keeping duties</li> <li>Experience in unloading shipping containers, however training will be provided to suitable applicants</li> <li>Proactive approach to OH&amp;S in the warehouse environment</li> <li>Other duties as required</li></ul> <p><strong>REQUIREMENTS</strong></p> <ul> <li>Previous warehousing experience</li> <li>Previous experience with racking and shelving systems would be an advantage.</li> <li>Attention to detail</li> <li>Ability to work under pressure and meet deadlines</li> <li>Current forklift license</li> <li>Mature outlook</li> <li>Excellent communication &amp; interpersonal skills</li> <li>Good time management skills</li> <li>Fresh ideas to help our organisations continued growth</li> <li>National police certificate</li> <li>Right to work in Australia</li></ul> <p> </p>  <p>This position's normal operating hours are Monday to Friday 8am to 4.30pm.</p>  <p>We offer a fun and challenging work environment with great teammates.</p>  <p>Suitably qualified and skilled candidates are encouraged to forward their resume and cover letter via the Apply for this job button below.</p>  <p>Applicants must have the legal right to work in Australia </p>  <p> </p>  <p>General Manager (Eastern States)</p><p>If you are interested in this new opportunity, please contact <strong>Amy Hatfield</strong> at Fuse Recruitment on <strong>test@example.com</strong> or <strong>0111 211 311</strong><strong> </strong>for a confidential discussion or apply now.</p>",
    contactMatches: [
      {
        type: 'Email',
        value: 'test@example.com',
        __typename: 'ContactMatches',
      },
      {
        type: 'Phone',
        value: '0111 211 311',
        __typename: 'ContactMatches',
      },
    ],
    sourcr: {
      image:
        'https://media.sourcr.com/seek/f11h67fxeq/amy-hatfield-1-21a296b091.jpeg',
      imageMobile:
        'https://media.sourcr.com/seek/f11h67fxeq/mobile-amy-hatfield-1-21a296b091.jpeg',
      link: 'https://www.sourcr.com/recruiter/amy-hatfield-1?utm_source=Seek&utm_medium=978&utm_campaign=amy-hatfield-1',
    },
  },
  '29663948': {
    advertiser: {
      id: '23772496',
      name: 'Maha',
    },
    classification: {
      id: '1212',
      description: 'Hospitality & Tourism',
    },
    subClassification: {
      id: '6052',
      description: 'Chefs/Cooks',
    },
    locationInfo: {
      area: 'CBD & Inner Suburbs',
      location: 'Melbourne',
      locationIds: ['18578'],
    },
    companyReviews: {
      id: 123,
      rating: 3.4,
      reviewCount: 86,
      reviewsUrl: '/companies/mahi-maha-23772496/reviews?jobId=29663948',
      fullName: 'Mahi Maha',
    },
    companySearchUrl: '/Mahi-Maha-jobs/at-this-company',
    hasRoleRequirements: false,
    adProductType: 'Classic',
    title: 'Pastry Chef & Chef de Partie',
    isPrivateAdvertiser: false,
    isLinkOut: true,
    isVerified: false,
    listingDate: '45m ago',
    workType: 'Full Time',
    workTypeIds: '242',
    salary: '',
    status: 'Active',
    video: null,
    content:
      "<p>Global Industrial has been a leader in the industrial racking &amp; industrial supply industry for the last 40 years. We are currently seeking an experienced warehousing team member for a casual position at our latest Sydney warehouse based in our facility in Prestons, with a view to the position becoming permanent full time depending upon the applicant.</p>  <p> </p>  <p><strong>ESSENTIAL JOB FUNCTIONS</strong></p> <ul> <li>Daily liaison with Supervisor for jobs allocation and reporting</li> <li>Picking and packing of orders in a busy small team</li> <li>Accurate packaging of orders</li> <li>Assembly of product and some fabrication work</li> <li>A willingness to attend to general warehousing and house-keeping duties</li> <li>Experience in unloading shipping containers, however training will be provided to suitable applicants</li> <li>Proactive approach to OH&amp;S in the warehouse environment</li> <li>Other duties as required</li></ul> <p><strong>REQUIREMENTS</strong></p> <ul> <li>Previous warehousing experience</li> <li>Previous experience with racking and shelving systems would be an advantage.</li> <li>Attention to detail</li> <li>Ability to work under pressure and meet deadlines</li> <li>Current forklift license</li> <li>Mature outlook</li> <li>Excellent communication &amp; interpersonal skills</li> <li>Good time management skills</li> <li>Fresh ideas to help our organisations continued growth</li> <li>National police certificate</li> <li>Right to work in Australia</li></ul> <p> </p>  <p>This position's normal operating hours are Monday to Friday 8am to 4.30pm.</p>  <p>We offer a fun and challenging work environment with great teammates.</p>  <p>Suitably qualified and skilled candidates are encouraged to forward their resume and cover letter via the Apply for this job button below.</p>  <p>Applicants must have the legal right to work in Australia </p>  <p> </p>",
    contactMatches: [],
    sourcr: null,
  },
  '29800269': {
    advertiser: {
      id: '25001934',
      name: 'Titan Recruitment Pty Ltd',
    },
    classification: {
      id: 6092,
      description: 'Manufacturing, Transport & Logistics',
    },
    subClassification: {
      id: 6108,
      description: 'Warehousing, Storage & Distribution',
    },
    locationInfo: {
      area: 'Eastern Suburbs',
      location: 'Perth',
      locationIds: ['18578'],
    },
    hasRoleRequirements: false,
    adProductType: 'Classic',
    title: 'Warehouse Supervisor',
    isPrivateAdvertiser: false,
    isLinkOut: true,
    isVerified: true,
    listingDate: '30m ago',
    workType: 'Full Time',
    workTypeIds: '242',
    salary: 'Bonus',
    status: 'Expired',
    video: {
      url: 'https://www.youtube.com/embed/7ZdyRlMSmPk',
      position: 'TOP',
    },
    companyReviews: null,
    content:
      "<p>Global Industrial has been a leader in the industrial racking &amp; industrial supply industry for the last 40 years. We are currently seeking an experienced warehousing team member for a casual position at our latest Sydney warehouse based in our facility in Prestons, with a view to the position becoming permanent full time depending upon the applicant.</p>  <p> </p>  <p><strong>ESSENTIAL JOB FUNCTIONS</strong></p> <ul> <li>Daily liaison with Supervisor for jobs allocation and reporting</li> <li>Picking and packing of orders in a busy small team</li> <li>Accurate packaging of orders</li> <li>Assembly of product and some fabrication work</li> <li>A willingness to attend to general warehousing and house-keeping duties</li> <li>Experience in unloading shipping containers, however training will be provided to suitable applicants</li> <li>Proactive approach to OH&amp;S in the warehouse environment</li> <li>Other duties as required</li></ul> <p><strong>REQUIREMENTS</strong></p> <ul> <li>Previous warehousing experience</li> <li>Previous experience with racking and shelving systems would be an advantage.</li> <li>Attention to detail</li> <li>Ability to work under pressure and meet deadlines</li> <li>Current forklift license</li> <li>Mature outlook</li> <li>Excellent communication &amp; interpersonal skills</li> <li>Good time management skills</li> <li>Fresh ideas to help our organisations continued growth</li> <li>National police certificate</li> <li>Right to work in Australia</li></ul> <p> </p>  <p>This position's normal operating hours are Monday to Friday 8am to 4.30pm.</p>  <p>We offer a fun and challenging work environment with great teammates.</p>  <p>Suitably qualified and skilled candidates are encouraged to forward their resume and cover letter via the Apply for this job button below.</p>  <p>Applicants must have the legal right to work in Australia </p>  <p> </p>  <p>General Manager (Eastern States)</p>",
    contactMatches: [],
    sourcr: null,
  },
  '29800267': {
    advertiser: {
      id: '29096318',
      name: 'Veritas Recruitment',
    },
    classification: {
      id: '6263',
      description: 'Design & Architecture',
    },
    subClassification: {
      id: '6267',
      description: 'Fashion & Textile Design',
    },
    locationInfo: {
      area: 'CBD & Inner Suburbs',
      location: 'Melbourne',
      locationIds: ['18578'],
    },
    hasRoleRequirements: false,
    adProductType: 'Branded',
    title: 'Textiles Designer',
    isPrivateAdvertiser: false,
    isLinkOut: true,
    isVerified: true,
    listingDate: '2h ago',
    workType: 'Full Time',
    workTypeIds: '242',
    salary: '$60000.00 - $70000.00 p.a.',
    salaryCurrencyLabel: 'NZD',
    status: 'Active',
    phoneNumber: '0444555666',
    video: {
      url: 'https://www.youtube.com/embed/7ZdyRlMSmPk',
      position: 'TOP',
    },
    companyReviews: {
      id: 123,
      rating: 3.4,
      reviewCount: 86,
      reviewsUrl: '/companies/macquarie-group-432455/reviews?jobId=32861690',
      fullName: 'Macquarie Group',
    },
    companySearchUrl: '/Macquarie-Group-jobs/at-this-company',
    content:
      "<p>Global Industrial has been a leader in the industrial racking &amp; industrial supply industry for the last 40 years. We are currently seeking an experienced warehousing team member for a casual position at our latest Sydney warehouse based in our facility in Prestons, with a view to the position becoming permanent full time depending upon the applicant.</p>  <p> </p>  <p><strong>ESSENTIAL JOB FUNCTIONS</strong></p> <ul> <li>Daily liaison with Supervisor for jobs allocation and reporting</li> <li>Picking and packing of orders in a busy small team</li> <li>Accurate packaging of orders</li> <li>Assembly of product and some fabrication work</li> <li>A willingness to attend to general warehousing and house-keeping duties</li> <li>Experience in unloading shipping containers, however training will be provided to suitable applicants</li> <li>Proactive approach to OH&amp;S in the warehouse environment</li> <li>Other duties as required</li></ul> <p><strong>REQUIREMENTS</strong></p> <ul> <li>Previous warehousing experience</li> <li>Previous experience with racking and shelving systems would be an advantage.</li> <li>Attention to detail</li> <li>Ability to work under pressure and meet deadlines</li> <li>Current forklift license</li> <li>Mature outlook</li> <li>Excellent communication &amp; interpersonal skills</li> <li>Good time management skills</li> <li>Fresh ideas to help our organisations continued growth</li> <li>National police certificate</li> <li>Right to work in Australia</li></ul> <p> </p>  <p>This position's normal operating hours are Monday to Friday 8am to 4.30pm.</p>  <p>We offer a fun and challenging work environment with great teammates.</p>  <p>Suitably qualified and skilled candidates are encouraged to forward their resume and cover letter via the Apply for this job button below.</p>  <p>Applicants must have the legal right to work in Australia </p>  <p> </p>  <p>General Manager (Eastern States)</p><p>If you are interested in this new opportunity, please contact <strong>Amy Hatfield</strong> at Fuse Recruitment on <strong>test@example.com</strong> or <strong>0111 211 311</strong><strong> </strong>for a confidential discussion or apply now.</p>",
    contactMatches: [
      {
        type: 'Email',
        value: 'test@example.com',
        __typename: 'ContactMatches',
      },
      {
        type: 'Phone',
        value: '0111 211 311',
        __typename: 'ContactMatches',
      },
    ],
  },
  '29800268': {
    advertiser: {
      id: '29096318',
      name: 'Veritas Recruitment',
    },
    classification: {
      id: '6092',
      description: 'Manufacturing, Transport & Logistics',
    },
    subClassification: {
      id: '6109',
      description: 'Purchasing, Procurement & Inventory',
    },
    locationInfo: {
      area: 'Bayside & South Eastern Suburbs',
      location: 'Melbourne',
      locationIds: ['18578'],
    },
    hasRoleRequirements: false,
    adProductType: 'Branded',
    title: 'Category Manager - Food Services',
    isPrivateAdvertiser: false,
    isLinkOut: false,
    isVerified: true,
    listingDate: '3h ago',
    workType: 'Full Time',
    workTypeIds: '242',
    salary: '$65000.00 - $70000.00 p.a.',
    status: 'Active',
    video: {
      url: 'https://www.youtube.com/embed/7ZdyRlMSmPk',
      position: 'TOP',
    },
    companyReviews: {
      id: 123,
      rating: 3.4,
      reviewCount: 86,
      reviewsUrl: '/companies/macquarie-group-432455/reviews?jobId=32861690',
      fullName: 'Macquarie Group',
    },
    companySearchUrl: '/Macquarie-Group-jobs/at-this-company',
    content:
      "<p>Global Industrial has been a leader in the industrial racking &amp; industrial supply industry for the last 40 years. We are currently seeking an experienced warehousing team member for a casual position at our latest Sydney warehouse based in our facility in Prestons, with a view to the position becoming permanent full time depending upon the applicant.</p>  <p> </p>  <p><strong>ESSENTIAL JOB FUNCTIONS</strong></p> <ul> <li>Daily liaison with Supervisor for jobs allocation and reporting</li> <li>Picking and packing of orders in a busy small team</li> <li>Accurate packaging of orders</li> <li>Assembly of product and some fabrication work</li> <li>A willingness to attend to general warehousing and house-keeping duties</li> <li>Experience in unloading shipping containers, however training will be provided to suitable applicants</li> <li>Proactive approach to OH&amp;S in the warehouse environment</li> <li>Other duties as required</li></ul> <p><strong>REQUIREMENTS</strong></p> <ul> <li>Previous warehousing experience</li> <li>Previous experience with racking and shelving systems would be an advantage.</li> <li>Attention to detail</li> <li>Ability to work under pressure and meet deadlines</li> <li>Current forklift license</li> <li>Mature outlook</li> <li>Excellent communication &amp; interpersonal skills</li> <li>Good time management skills</li> <li>Fresh ideas to help our organisations continued growth</li> <li>National police certificate</li> <li>Right to work in Australia</li></ul> <p> </p>  <p>This position's normal operating hours are Monday to Friday 8am to 4.30pm.</p>  <p>We offer a fun and challenging work environment with great teammates.</p>  <p>Suitably qualified and skilled candidates are encouraged to forward their resume and cover letter via the Apply for this job button below.</p>  <p>Applicants must have the legal right to work in Australia </p>  <p> </p>  <p>General Manager (Eastern States)</p><p>If you are interested in this new opportunity, please contact <strong>Amy Hatfield</strong> at Fuse Recruitment on <strong>test@example.com</strong> or <strong>0111 211 311</strong><strong> </strong>for a confidential discussion or apply now.</p>",
    contactMatches: [
      {
        type: 'Email',
        value: 'test@example.com',
        __typename: 'ContactMatches',
      },
      {
        type: 'Phone',
        value: '0111 211 311',
        __typename: 'ContactMatches',
      },
    ],
  },
  '29800266': {
    advertiser: {
      id: '29096318',
      name: 'Veritas Recruitment',
    },
    classification: {
      id: '6008',
      description: 'Marketing & Communications',
    },
    subClassification: {
      id: '6015',
      description: 'Marketing Assistants/Coordinators',
    },
    locationInfo: {
      area: 'Bayside & South Eastern Suburbs',
      location: 'Melbourne',
      locationIds: ['18578'],
    },
    hasRoleRequirements: false,
    adProductType: 'Branded',
    title: 'Category Manager - Food Services',
    isPrivateAdvertiser: false,
    isLinkOut: false,
    isVerified: true,
    listingDate: '5h ago',
    workType: 'Full Time',
    workTypeIds: '242',
    salary: '$65000.00 - $70000.00 p.a.',
    status: 'Active',
    video: {
      url: 'https://www.youtube.com/embed/7ZdyRlMSmPk',
      position: 'TOP',
    },
    companyReviews: {
      id: 123,
      rating: 3.4,
      reviewCount: 86,
      reviewsUrl: '/companies/macquarie-group-432455/reviews?jobId=32861690',
      fullName: 'Macquarie Group',
    },
    companySearchUrl: '/Macquarie-Group-jobs/at-this-company',
    content:
      "<p>Global Industrial has been a leader in the industrial racking &amp; industrial supply industry for the last 40 years. We are currently seeking an experienced warehousing team member for a casual position at our latest Sydney warehouse based in our facility in Prestons, with a view to the position becoming permanent full time depending upon the applicant.</p>  <p> </p>  <p><strong>ESSENTIAL JOB FUNCTIONS</strong></p> <ul> <li>Daily liaison with Supervisor for jobs allocation and reporting</li> <li>Picking and packing of orders in a busy small team</li> <li>Accurate packaging of orders</li> <li>Assembly of product and some fabrication work</li> <li>A willingness to attend to general warehousing and house-keeping duties</li> <li>Experience in unloading shipping containers, however training will be provided to suitable applicants</li> <li>Proactive approach to OH&amp;S in the warehouse environment</li> <li>Other duties as required</li></ul> <p><strong>REQUIREMENTS</strong></p> <ul> <li>Previous warehousing experience</li> <li>Previous experience with racking and shelving systems would be an advantage.</li> <li>Attention to detail</li> <li>Ability to work under pressure and meet deadlines</li> <li>Current forklift license</li> <li>Mature outlook</li> <li>Excellent communication &amp; interpersonal skills</li> <li>Good time management skills</li> <li>Fresh ideas to help our organisations continued growth</li> <li>National police certificate</li> <li>Right to work in Australia</li></ul> <p> </p>  <p>This position's normal operating hours are Monday to Friday 8am to 4.30pm.</p>  <p>We offer a fun and challenging work environment with great teammates.</p>  <p>Suitably qualified and skilled candidates are encouraged to forward their resume and cover letter via the Apply for this job button below.</p>  <p>Applicants must have the legal right to work in Australia </p>  <p> </p>  <p>General Manager (Eastern States)</p><p>If you are interested in this new opportunity, please contact <strong>Amy Hatfield</strong> at Fuse Recruitment on <strong>test@example.com</strong> or <strong>0111 211 311</strong><strong> </strong>for a confidential discussion or apply now.</p>",
    contactMatches: [
      {
        type: 'Email',
        value: 'test@example.com',
        __typename: 'ContactMatches',
      },
      {
        type: 'Phone',
        value: '0111 211 311',
        __typename: 'ContactMatches',
      },
    ],
  },
  '29800264': {
    advertiser: {
      id: '29096318',
      name: 'Veritas Recruitment',
    },
    classification: {
      id: '6008',
      description: 'Marketing & Communications',
    },
    subClassification: {
      id: '6018',
      description: 'Product Management & Development',
    },
    locationInfo: {
      area: 'Bayside & South Eastern Suburbs',
      location: 'Melbourne',
      locationIds: ['18578'],
    },
    hasRoleRequirements: false,
    adProductType: 'Branded',
    title: 'Category Manager - Food Services',
    isPrivateAdvertiser: false,
    isLinkOut: false,
    isVerified: true,
    listingDate: '6h ago',
    workType: 'Casual/Vacation',
    workTypeIds: '245',
    salary: '$65000.00 - $70000.00 p.a.',
    status: 'Active',
    video: {
      url: 'https://www.youtube.com/embed/7ZdyRlMSmPk',
      position: 'TOP',
    },
    companyReviews: {
      id: 123,
      rating: 3.4,
      reviewCount: 86,
      reviewsUrl: '/companies/macquarie-group-432455/reviews?jobId=32861690',
      fullName: 'Macquarie Group',
    },
    companySearchUrl: '/Macquarie-Group-jobs/at-this-company',
    content:
      "<p>Global Industrial has been a leader in the industrial racking &amp; industrial supply industry for the last 40 years. We are currently seeking an experienced warehousing team member for a casual position at our latest Sydney warehouse based in our facility in Prestons, with a view to the position becoming permanent full time depending upon the applicant.</p>  <p> </p>  <p><strong>ESSENTIAL JOB FUNCTIONS</strong></p> <ul> <li>Daily liaison with Supervisor for jobs allocation and reporting</li> <li>Picking and packing of orders in a busy small team</li> <li>Accurate packaging of orders</li> <li>Assembly of product and some fabrication work</li> <li>A willingness to attend to general warehousing and house-keeping duties</li> <li>Experience in unloading shipping containers, however training will be provided to suitable applicants</li> <li>Proactive approach to OH&amp;S in the warehouse environment</li> <li>Other duties as required</li></ul> <p><strong>REQUIREMENTS</strong></p> <ul> <li>Previous warehousing experience</li> <li>Previous experience with racking and shelving systems would be an advantage.</li> <li>Attention to detail</li> <li>Ability to work under pressure and meet deadlines</li> <li>Current forklift license</li> <li>Mature outlook</li> <li>Excellent communication &amp; interpersonal skills</li> <li>Good time management skills</li> <li>Fresh ideas to help our organisations continued growth</li> <li>National police certificate</li> <li>Right to work in Australia</li></ul> <p> </p>  <p>This position's normal operating hours are Monday to Friday 8am to 4.30pm.</p>  <p>We offer a fun and challenging work environment with great teammates.</p>  <p>Suitably qualified and skilled candidates are encouraged to forward their resume and cover letter via the Apply for this job button below.</p>  <p>Applicants must have the legal right to work in Australia </p>  <p> </p>  <p>General Manager (Eastern States)</p><p>If you are interested in this new opportunity, please contact <strong>Amy Hatfield</strong> at Fuse Recruitment on <strong>test@example.com</strong> or <strong>0111 211 311</strong><strong> </strong>for a confidential discussion or apply now.</p>",
    contactMatches: [
      {
        type: 'Email',
        value: 'test@example.com',
        __typename: 'ContactMatches',
      },
      {
        type: 'Phone',
        value: '0111 211 311',
        __typename: 'ContactMatches',
      },
    ],
  },
  '29800265': {
    advertiser: {
      id: '29096318',
      name: 'Veritas Recruitment',
    },
    classification: {
      id: '6008',
      description: 'Marketing & Communications',
    },
    subClassification: {
      id: '6018',
      description: 'Product Management & Development',
    },
    locationInfo: {
      area: 'Bayside & South Eastern Suburbs',
      location: 'Melbourne',
      locationIds: ['18578'],
    },
    hasRoleRequirements: false,
    adProductType: 'Branded',
    title: 'Category Manager - Food Services',
    isPrivateAdvertiser: false,
    isLinkOut: false,
    isVerified: true,
    listingDate: '1 Jun 2022',
    workType: 'Casual/Vacation',
    workTypeIds: '245',
    salary: '$65000.00 - $70000.00 p.a.',
    status: 'Active',
    video: {
      url: 'https://www.youtube.com/embed/7ZdyRlMSmPk',
      position: 'TOP',
    },
    companyReviews: {
      id: 123,
      rating: 3.4,
      reviewCount: 86,
      reviewsUrl: '/companies/macquarie-group-432455/reviews?jobId=32861690',
      fullName: 'Macquarie Group',
    },
    companySearchUrl: '/Macquarie-Group-jobs/at-this-company',
    content:
      "<p>Global Industrial has been a leader in the industrial racking &amp; industrial supply industry for the last 40 years. We are currently seeking an experienced warehousing team member for a casual position at our latest Sydney warehouse based in our facility in Prestons, with a view to the position becoming permanent full time depending upon the applicant.</p>  <p> </p>  <p><strong>ESSENTIAL JOB FUNCTIONS</strong></p> <ul> <li>Daily liaison with Supervisor for jobs allocation and reporting</li> <li>Picking and packing of orders in a busy small team</li> <li>Accurate packaging of orders</li> <li>Assembly of product and some fabrication work</li> <li>A willingness to attend to general warehousing and house-keeping duties</li> <li>Experience in unloading shipping containers, however training will be provided to suitable applicants</li> <li>Proactive approach to OH&amp;S in the warehouse environment</li> <li>Other duties as required</li></ul> <p><strong>REQUIREMENTS</strong></p> <ul> <li>Previous warehousing experience</li> <li>Previous experience with racking and shelving systems would be an advantage.</li> <li>Attention to detail</li> <li>Ability to work under pressure and meet deadlines</li> <li>Current forklift license</li> <li>Mature outlook</li> <li>Excellent communication &amp; interpersonal skills</li> <li>Good time management skills</li> <li>Fresh ideas to help our organisations continued growth</li> <li>National police certificate</li> <li>Right to work in Australia</li></ul> <p> </p>  <p>This position's normal operating hours are Monday to Friday 8am to 4.30pm.</p>  <p>We offer a fun and challenging work environment with great teammates.</p>  <p>Suitably qualified and skilled candidates are encouraged to forward their resume and cover letter via the Apply for this job button below.</p>  <p>Applicants must have the legal right to work in Australia </p>  <p> </p>  <p>General Manager (Eastern States)</p><p>If you are interested in this new opportunity, please contact <strong>Amy Hatfield</strong> at Fuse Recruitment on <strong>test@example.com</strong> or <strong>0111 211 311</strong><strong> </strong>for a confidential discussion or apply now.</p>",
    contactMatches: [
      {
        type: 'Email',
        value: 'test@example.com',
        __typename: 'ContactMatches',
      },
      {
        type: 'Phone',
        value: '0111 211 311',
        __typename: 'ContactMatches',
      },
    ],
  },
  '29800262': {
    advertiser: {
      id: '24812974',
      name: 'T2 Tea',
    },
    classification: {
      id: '6043',
      description: 'Retail & Consumer Products',
    },
    subClassification: {
      id: '6050',
      description: 'Retail Assistants',
    },
    locationInfo: {
      area: 'CBD, Inner & Western Suburbs',
      location: 'Perth',
      locationIds: ['18578'],
    },
    hasRoleRequirements: false,
    adProductType: 'Branded',
    title: 'Category Manager - Food Services',
    isPrivateAdvertiser: false,
    isLinkOut: false,
    isVerified: true,
    listingDate: '10h ago',
    workType: 'Casual/Vacation',
    workTypeIds: '245',
    salary: '',
    status: 'Active',
    video: {
      url: 'https://www.youtube.com/embed/7ZdyRlMSmPk',
      position: 'TOP',
    },
    companyReviews: {
      id: 123,
      rating: 3.4,
      reviewCount: 86,
      reviewsUrl: '/companies/macquarie-group-432455/reviews?jobId=32861690',
      fullName: 'Macquarie Group',
    },
    companySearchUrl: '/Macquarie-Group-jobs/at-this-company',
    content:
      "<p>Global Industrial has been a leader in the industrial racking &amp; industrial supply industry for the last 40 years. We are currently seeking an experienced warehousing team member for a casual position at our latest Sydney warehouse based in our facility in Prestons, with a view to the position becoming permanent full time depending upon the applicant.</p>  <p> </p>  <p><strong>ESSENTIAL JOB FUNCTIONS</strong></p> <ul> <li>Daily liaison with Supervisor for jobs allocation and reporting</li> <li>Picking and packing of orders in a busy small team</li> <li>Accurate packaging of orders</li> <li>Assembly of product and some fabrication work</li> <li>A willingness to attend to general warehousing and house-keeping duties</li> <li>Experience in unloading shipping containers, however training will be provided to suitable applicants</li> <li>Proactive approach to OH&amp;S in the warehouse environment</li> <li>Other duties as required</li></ul> <p><strong>REQUIREMENTS</strong></p> <ul> <li>Previous warehousing experience</li> <li>Previous experience with racking and shelving systems would be an advantage.</li> <li>Attention to detail</li> <li>Ability to work under pressure and meet deadlines</li> <li>Current forklift license</li> <li>Mature outlook</li> <li>Excellent communication &amp; interpersonal skills</li> <li>Good time management skills</li> <li>Fresh ideas to help our organisations continued growth</li> <li>National police certificate</li> <li>Right to work in Australia</li></ul> <p> </p>  <p>This position's normal operating hours are Monday to Friday 8am to 4.30pm.</p>  <p>We offer a fun and challenging work environment with great teammates.</p>  <p>Suitably qualified and skilled candidates are encouraged to forward their resume and cover letter via the Apply for this job button below.</p>  <p>Applicants must have the legal right to work in Australia </p>  <p> </p>  <p>General Manager (Eastern States)</p><p>If you are interested in this new opportunity, please contact <strong>Amy Hatfield</strong> at Fuse Recruitment on <strong>test@example.com</strong> or <strong>0111 211 311</strong><strong> </strong>for a confidential discussion or apply now.</p>",
    contactMatches: [
      {
        type: 'Email',
        value: 'test@example.com',
        __typename: 'ContactMatches',
      },
      {
        type: 'Phone',
        value: '0111 211 311',
        __typename: 'ContactMatches',
      },
    ],
  },
  '29800261': {
    advertiser: {
      id: '23607451',
      name: 'Talent International – SARA Winner Large  Recruitment Agency 2014 - SEEK',
    },
    classification: {
      id: '6281',
      description: 'Information & Communication Technology',
    },
    subClassification: {
      id: '6287',
      description: 'Developers/Programmers',
    },
    locationInfo: {
      area: '',
      location: 'ACT',
      locationIds: ['18578'],
    },
    hasRoleRequirements: false,
    adProductType: 'Branded',
    title: '.NET developer',
    isPrivateAdvertiser: false,
    isLinkOut: false,
    isVerified: true,
    listingDate: '20h ago',
    workType: 'Full Time',
    workTypeIds: '242',
    salary: '',
    status: 'Active',
    video: {
      url: 'https://www.youtube.com/embed/7ZdyRlMSmPk',
      position: 'TOP',
    },
    companyReviews: {
      id: 123,
      rating: 3.4,
      reviewCount: 86,
      reviewsUrl: '/companies/macquarie-group-432455/reviews?jobId=32861690',
      fullName: 'Macquarie Group',
    },
    companySearchUrl: '/Macquarie-Group-jobs/at-this-company',
    content:
      "<p>Global Industrial has been a leader in the industrial racking &amp; industrial supply industry for the last 40 years. We are currently seeking an experienced warehousing team member for a casual position at our latest Sydney warehouse based in our facility in Prestons, with a view to the position becoming permanent full time depending upon the applicant.</p>  <p> </p>  <p><strong>ESSENTIAL JOB FUNCTIONS</strong></p> <ul> <li>Daily liaison with Supervisor for jobs allocation and reporting</li> <li>Picking and packing of orders in a busy small team</li> <li>Accurate packaging of orders</li> <li>Assembly of product and some fabrication work</li> <li>A willingness to attend to general warehousing and house-keeping duties</li> <li>Experience in unloading shipping containers, however training will be provided to suitable applicants</li> <li>Proactive approach to OH&amp;S in the warehouse environment</li> <li>Other duties as required</li></ul> <p><strong>REQUIREMENTS</strong></p> <ul> <li>Previous warehousing experience</li> <li>Previous experience with racking and shelving systems would be an advantage.</li> <li>Attention to detail</li> <li>Ability to work under pressure and meet deadlines</li> <li>Current forklift license</li> <li>Mature outlook</li> <li>Excellent communication &amp; interpersonal skills</li> <li>Good time management skills</li> <li>Fresh ideas to help our organisations continued growth</li> <li>National police certificate</li> <li>Right to work in Australia</li></ul> <p> </p>  <p>This position's normal operating hours are Monday to Friday 8am to 4.30pm.</p>  <p>We offer a fun and challenging work environment with great teammates.</p>  <p>Suitably qualified and skilled candidates are encouraged to forward their resume and cover letter via the Apply for this job button below.</p>  <p>Applicants must have the legal right to work in Australia </p>  <p> </p>  <p>General Manager (Eastern States)</p><p>If you are interested in this new opportunity, please contact <strong>Amy Hatfield</strong> at Fuse Recruitment on <strong>test@example.com</strong> or <strong>0111 211 311</strong><strong> </strong>for a confidential discussion or apply now.</p>",
    contactMatches: [
      {
        type: 'Email',
        value: 'test@example.com',
        __typename: 'ContactMatches',
      },
      {
        type: 'Phone',
        value: '0111 211 311',
        __typename: 'ContactMatches',
      },
    ],
  },
  '34536098': {
    advertiser: {
      id: '20127081',
      name: 'Jobwire-Brisbane',
    },
    classification: {
      id: '6058',
      description: 'Mining, Resources & Energy',
    },
    subClassification: {
      id: '6075',
      description: 'Other',
    },
    locationInfo: {
      area: 'CBD & Inner Suburbs',
      location: 'Brisbane',
      locationIds: ['18578'],
    },
    hasRoleRequirements: false,
    adProductType: 'Branded',
    title: 'Site Manager',
    isPrivateAdvertiser: false,
    isLinkOut: false,
    isVerified: true,
    listingDate: '1d ago',
    workType: 'Casual/Vacation',
    workTypeIds: '245',
    salary: '',
    status: 'Active',
    video: {
      url: 'https://www.youtube.com/embed/7ZdyRlMSmPk',
      position: 'TOP',
    },
    companyReviews: {
      id: 123,
      rating: 3.4,
      reviewCount: 86,
      reviewsUrl: '/companies/macquarie-group-432455/reviews?jobId=32861690',
      fullName: 'Macquarie Group',
    },
    companySearchUrl: '/Macquarie-Group-jobs/at-this-company',
    content:
      "<p>Global Industrial has been a leader in the industrial racking &amp; industrial supply industry for the last 40 years. We are currently seeking an experienced warehousing team member for a casual position at our latest Sydney warehouse based in our facility in Prestons, with a view to the position becoming permanent full time depending upon the applicant.</p>  <p> </p>  <p><strong>ESSENTIAL JOB FUNCTIONS</strong></p> <ul> <li>Daily liaison with Supervisor for jobs allocation and reporting</li> <li>Picking and packing of orders in a busy small team</li> <li>Accurate packaging of orders</li> <li>Assembly of product and some fabrication work</li> <li>A willingness to attend to general warehousing and house-keeping duties</li> <li>Experience in unloading shipping containers, however training will be provided to suitable applicants</li> <li>Proactive approach to OH&amp;S in the warehouse environment</li> <li>Other duties as required</li></ul> <p><strong>REQUIREMENTS</strong></p> <ul> <li>Previous warehousing experience</li> <li>Previous experience with racking and shelving systems would be an advantage.</li> <li>Attention to detail</li> <li>Ability to work under pressure and meet deadlines</li> <li>Current forklift license</li> <li>Mature outlook</li> <li>Excellent communication &amp; interpersonal skills</li> <li>Good time management skills</li> <li>Fresh ideas to help our organisations continued growth</li> <li>National police certificate</li> <li>Right to work in Australia</li></ul> <p> </p>  <p>This position's normal operating hours are Monday to Friday 8am to 4.30pm.</p>  <p>We offer a fun and challenging work environment with great teammates.</p>  <p>Suitably qualified and skilled candidates are encouraged to forward their resume and cover letter via the Apply for this job button below.</p>  <p>Applicants must have the legal right to work in Australia </p>  <p> </p>  <p>General Manager (Eastern States)</p><p>If you are interested in this new opportunity, please contact <strong>Amy Hatfield</strong> at Fuse Recruitment on <strong>test@example.com</strong> or <strong>0111 211 311</strong><strong> </strong>for a confidential discussion or apply now.</p>",
    contactMatches: [
      {
        type: 'Email',
        value: 'test@example.com',
        __typename: 'ContactMatches',
      },
      {
        type: 'Phone',
        value: '0111 211 311',
        __typename: 'ContactMatches',
      },
    ],
  },
  '29800259': {
    advertiser: {
      id: '21496137',
      name: 'HealthyPeople',
    },
    classification: {
      id: '6246',
      description: 'Sport & Recreation',
    },
    subClassification: {
      id: '6248',
      description: 'Fitness & Personal Training',
    },
    locationInfo: {
      area: 'Western Suburbs',
      location: 'Melbourne',
      locationIds: ['18578'],
    },
    hasRoleRequirements: false,
    adProductType: 'Branded',
    title: 'Personal Trainers Wanted - Goodlife Point Cook',
    isPrivateAdvertiser: false,
    isLinkOut: false,
    isVerified: true,
    listingDate: '2d ago',
    workType: 'Contract/Temp',
    workTypeIds: '244',
    salary: '',
    status: 'Active',
    video: {
      url: 'https://www.youtube.com/embed/7ZdyRlMSmPk',
      position: 'TOP',
    },
    companyReviews: null,
    content:
      "<p>Global Industrial has been a leader in the industrial racking &amp; industrial supply industry for the last 40 years. We are currently seeking an experienced warehousing team member for a casual position at our latest Sydney warehouse based in our facility in Prestons, with a view to the position becoming permanent full time depending upon the applicant.</p>  <p> </p>  <p><strong>ESSENTIAL JOB FUNCTIONS</strong></p> <ul> <li>Daily liaison with Supervisor for jobs allocation and reporting</li> <li>Picking and packing of orders in a busy small team</li> <li>Accurate packaging of orders</li> <li>Assembly of product and some fabrication work</li> <li>A willingness to attend to general warehousing and house-keeping duties</li> <li>Experience in unloading shipping containers, however training will be provided to suitable applicants</li> <li>Proactive approach to OH&amp;S in the warehouse environment</li> <li>Other duties as required</li></ul> <p><strong>REQUIREMENTS</strong></p> <ul> <li>Previous warehousing experience</li> <li>Previous experience with racking and shelving systems would be an advantage.</li> <li>Attention to detail</li> <li>Ability to work under pressure and meet deadlines</li> <li>Current forklift license</li> <li>Mature outlook</li> <li>Excellent communication &amp; interpersonal skills</li> <li>Good time management skills</li> <li>Fresh ideas to help our organisations continued growth</li> <li>National police certificate</li> <li>Right to work in Australia</li></ul> <p> </p>  <p>This position's normal operating hours are Monday to Friday 8am to 4.30pm.</p>  <p>We offer a fun and challenging work environment with great teammates.</p>  <p>Suitably qualified and skilled candidates are encouraged to forward their resume and cover letter via the Apply for this job button below.</p>  <p>Applicants must have the legal right to work in Australia </p>  <p> </p>  <p>General Manager (Eastern States)</p><p>If you are interested in this new opportunity, please contact <strong>Amy Hatfield</strong> at Fuse Recruitment on <strong>test@example.com</strong> or <strong>0111 211 311</strong><strong> </strong>for a confidential discussion or apply now.</p>",
    contactMatches: [
      {
        type: 'Email',
        value: 'test@example.com',
        __typename: 'ContactMatches',
      },
      {
        type: 'Phone',
        value: '0111 211 311',
        __typename: 'ContactMatches',
      },
    ],
  },
  '29662612': {
    advertiser: {
      id: '3620',
      name: 'Australian Personnel Solutions',
    },
    classification: {
      id: '6092',
      description: 'Manufacturing, Transport & Logistics',
    },
    subClassification: {
      id: '6111',
      description: 'Road Transport',
    },
    locationInfo: {
      area: 'Northern Suburbs',
      location: 'Melbourne',
      locationIds: ['18578'],
    },
    hasRoleRequirements: false,
    adProductType: 'Branded',
    title: 'MR & HR DRIVERS!',
    isPrivateAdvertiser: false,
    isLinkOut: false,
    isVerified: true,
    listingDate: '2d ago',
    workType: 'Casual/Vacation',
    workTypeIds: '245',
    salary: 'Rates start at $30.86',
    status: 'Active',
    video: {
      url: 'https://www.youtube.com/embed/7ZdyRlMSmPk',
      position: 'TOP',
    },
    companyReviews: null,
    content:
      "<p>Global Industrial has been a leader in the industrial racking &amp; industrial supply industry for the last 40 years. We are currently seeking an experienced warehousing team member for a casual position at our latest Sydney warehouse based in our facility in Prestons, with a view to the position becoming permanent full time depending upon the applicant.</p>  <p> </p>  <p><strong>ESSENTIAL JOB FUNCTIONS</strong></p> <ul> <li>Daily liaison with Supervisor for jobs allocation and reporting</li> <li>Picking and packing of orders in a busy small team</li> <li>Accurate packaging of orders</li> <li>Assembly of product and some fabrication work</li> <li>A willingness to attend to general warehousing and house-keeping duties</li> <li>Experience in unloading shipping containers, however training will be provided to suitable applicants</li> <li>Proactive approach to OH&amp;S in the warehouse environment</li> <li>Other duties as required</li></ul> <p><strong>REQUIREMENTS</strong></p> <ul> <li>Previous warehousing experience</li> <li>Previous experience with racking and shelving systems would be an advantage.</li> <li>Attention to detail</li> <li>Ability to work under pressure and meet deadlines</li> <li>Current forklift license</li> <li>Mature outlook</li> <li>Excellent communication &amp; interpersonal skills</li> <li>Good time management skills</li> <li>Fresh ideas to help our organisations continued growth</li> <li>National police certificate</li> <li>Right to work in Australia</li></ul> <p> </p>  <p>This position's normal operating hours are Monday to Friday 8am to 4.30pm.</p>  <p>We offer a fun and challenging work environment with great teammates.</p>  <p>Suitably qualified and skilled candidates are encouraged to forward their resume and cover letter via the Apply for this job button below.</p>  <p>Applicants must have the legal right to work in Australia </p>  <p> </p>  <p>General Manager (Eastern States)</p><p>If you are interested in this new opportunity, please contact <strong>Amy Hatfield</strong> at Fuse Recruitment on <strong>test@example.com</strong> or <strong>0111 211 311</strong><strong> </strong>for a confidential discussion or apply now.</p>",
    contactMatches: [
      {
        type: 'Email',
        value: 'test@example.com',
        __typename: 'ContactMatches',
      },
      {
        type: 'Phone',
        value: '0111 211 311',
        __typename: 'ContactMatches',
      },
    ],
  },
  '29800257': {
    advertiser: {
      id: '18454059',
      name: 'Flexi Staff Pty Ltd',
    },
    classification: {
      id: '1211',
      description: 'Healthcare & Medical',
    },
    subClassification: {
      id: '6339',
      description: 'Nursing - Aged Care',
    },
    locationInfo: {
      area: '',
      location: 'Bunbury & South West',
      locationIds: ['18578'],
    },
    hasRoleRequirements: false,
    adProductType: 'Branded',
    title: 'Aged Carer',
    isPrivateAdvertiser: false,
    isLinkOut: false,
    isVerified: true,
    listingDate: '20h ago',
    workType: 'Contract/Temp',
    workTypeIds: '244',
    salary: '$25 - $27 p.h.',
    status: 'Active',
    video: {
      url: 'https://www.youtube.com/embed/7ZdyRlMSmPk',
      position: 'TOP',
    },
    companyReviews: null,
    content:
      "<p>Global Industrial has been a leader in the industrial racking &amp; industrial supply industry for the last 40 years. We are currently seeking an experienced warehousing team member for a casual position at our latest Sydney warehouse based in our facility in Prestons, with a view to the position becoming permanent full time depending upon the applicant.</p>  <p> </p>  <p><strong>ESSENTIAL JOB FUNCTIONS</strong></p> <ul> <li>Daily liaison with Supervisor for jobs allocation and reporting</li> <li>Picking and packing of orders in a busy small team</li> <li>Accurate packaging of orders</li> <li>Assembly of product and some fabrication work</li> <li>A willingness to attend to general warehousing and house-keeping duties</li> <li>Experience in unloading shipping containers, however training will be provided to suitable applicants</li> <li>Proactive approach to OH&amp;S in the warehouse environment</li> <li>Other duties as required</li></ul> <p><strong>REQUIREMENTS</strong></p> <ul> <li>Previous warehousing experience</li> <li>Previous experience with racking and shelving systems would be an advantage.</li> <li>Attention to detail</li> <li>Ability to work under pressure and meet deadlines</li> <li>Current forklift license</li> <li>Mature outlook</li> <li>Excellent communication &amp; interpersonal skills</li> <li>Good time management skills</li> <li>Fresh ideas to help our organisations continued growth</li> <li>National police certificate</li> <li>Right to work in Australia</li></ul> <p> </p>  <p>This position's normal operating hours are Monday to Friday 8am to 4.30pm.</p>  <p>We offer a fun and challenging work environment with great teammates.</p>  <p>Suitably qualified and skilled candidates are encouraged to forward their resume and cover letter via the Apply for this job button below.</p>  <p>Applicants must have the legal right to work in Australia </p>  <p> </p>  <p>General Manager (Eastern States)</p><p>If you are interested in this new opportunity, please contact <strong>Amy Hatfield</strong> at Fuse Recruitment on <strong>test@example.com</strong> or <strong>0111 211 311</strong><strong> </strong>for a confidential discussion or apply now.</p>",
    contactMatches: [
      {
        type: 'Email',
        value: 'test@example.com',
        __typename: 'ContactMatches',
      },
      {
        type: 'Phone',
        value: '0111 211 311',
        __typename: 'ContactMatches',
      },
    ],
  },
  '29800258': {
    advertiser: {
      id: '18454059',
      name: 'Flexi Staff Pty Ltd',
    },
    classification: {
      id: '1212',
      description: 'Hospitality & Tourism',
    },
    subClassification: {
      id: '6052',
      description: 'Chefs/Cooks',
    },
    locationInfo: {
      area: 'CBD, Inner & Western Suburbs',
      location: 'Perth',
      locationIds: ['18578'],
    },
    hasRoleRequirements: false,
    adProductType: 'Classic',
    title: 'Chefs & Cooks',
    isPrivateAdvertiser: false,
    isLinkOut: false,
    isVerified: true,
    listingDate: '10d ago',
    workType: 'Contract/Temp',
    workTypeIds: '244',
    salary: '$24 - $27 p.h. + Penalty Rates',
    status: 'Active',
    video: {
      url: 'https://www.youtube.com/embed/7ZdyRlMSmPk',
      position: 'TOP',
    },
    companyReviews: null,
    content:
      "<p>Global Industrial has been a leader in the industrial racking &amp; industrial supply industry for the last 40 years. We are currently seeking an experienced warehousing team member for a casual position at our latest Sydney warehouse based in our facility in Prestons, with a view to the position becoming permanent full time depending upon the applicant.</p>  <p> </p>  <p><strong>ESSENTIAL JOB FUNCTIONS</strong></p> <ul> <li>Daily liaison with Supervisor for jobs allocation and reporting</li> <li>Picking and packing of orders in a busy small team</li> <li>Accurate packaging of orders</li> <li>Assembly of product and some fabrication work</li> <li>A willingness to attend to general warehousing and house-keeping duties</li> <li>Experience in unloading shipping containers, however training will be provided to suitable applicants</li> <li>Proactive approach to OH&amp;S in the warehouse environment</li> <li>Other duties as required</li></ul> <p><strong>REQUIREMENTS</strong></p> <ul> <li>Previous warehousing experience</li> <li>Previous experience with racking and shelving systems would be an advantage.</li> <li>Attention to detail</li> <li>Ability to work under pressure and meet deadlines</li> <li>Current forklift license</li> <li>Mature outlook</li> <li>Excellent communication &amp; interpersonal skills</li> <li>Good time management skills</li> <li>Fresh ideas to help our organisations continued growth</li> <li>National police certificate</li> <li>Right to work in Australia</li></ul> <p> </p>  <p>This position's normal operating hours are Monday to Friday 8am to 4.30pm.</p>  <p>We offer a fun and challenging work environment with great teammates.</p>  <p>Suitably qualified and skilled candidates are encouraged to forward their resume and cover letter via the Apply for this job button below.</p>  <p>Applicants must have the legal right to work in Australia </p>  <p> </p>  <p>General Manager (Eastern States)</p><p>If you are interested in this new opportunity, please contact <strong>Amy Hatfield</strong> at Fuse Recruitment on <strong>test@example.com</strong> or <strong>0111 211 311</strong><strong> </strong>for a confidential discussion or apply now.</p>",
    contactMatches: [
      {
        type: 'Email',
        value: 'test@example.com',
        __typename: 'ContactMatches',
      },
      {
        type: 'Phone',
        value: '0111 211 311',
        __typename: 'ContactMatches',
      },
    ],
  },
  '29799290': {
    advertiser: {
      id: '34380634',
      name: 'Cottage Lane Automotive',
    },
    classification: {
      id: '1225',
      description: 'Trades & Services',
    },
    subClassification: {
      id: '1328',
      description: 'Automotive Trades',
    },
    locationInfo: {
      area: '',
      location: 'Adelaide',
      locationIds: ['18578'],
    },
    hasRoleRequirements: false,
    adProductType: 'Classic',
    title: 'Motor Mechanic',
    isPrivateAdvertiser: false,
    isLinkOut: false,
    isVerified: true,
    listingDate: '15d ago',
    workType: 'Full Time',
    workTypeIds: '242',
    salary: '$45,000 to $55,000 pa based on skills & experience',
    status: 'Active',
    video: {
      url: 'https://www.youtube.com/embed/7ZdyRlMSmPk',
      position: 'TOP',
    },
    companyReviews: null,
    content:
      "<p>Global Industrial has been a leader in the industrial racking &amp; industrial supply industry for the last 40 years. We are currently seeking an experienced warehousing team member for a casual position at our latest Sydney warehouse based in our facility in Prestons, with a view to the position becoming permanent full time depending upon the applicant.</p>  <p> </p>  <p><strong>ESSENTIAL JOB FUNCTIONS</strong></p> <ul> <li>Daily liaison with Supervisor for jobs allocation and reporting</li> <li>Picking and packing of orders in a busy small team</li> <li>Accurate packaging of orders</li> <li>Assembly of product and some fabrication work</li> <li>A willingness to attend to general warehousing and house-keeping duties</li> <li>Experience in unloading shipping containers, however training will be provided to suitable applicants</li> <li>Proactive approach to OH&amp;S in the warehouse environment</li> <li>Other duties as required</li></ul> <p><strong>REQUIREMENTS</strong></p> <ul> <li>Previous warehousing experience</li> <li>Previous experience with racking and shelving systems would be an advantage.</li> <li>Attention to detail</li> <li>Ability to work under pressure and meet deadlines</li> <li>Current forklift license</li> <li>Mature outlook</li> <li>Excellent communication &amp; interpersonal skills</li> <li>Good time management skills</li> <li>Fresh ideas to help our organisations continued growth</li> <li>National police certificate</li> <li>Right to work in Australia</li></ul> <p> </p>  <p>This position's normal operating hours are Monday to Friday 8am to 4.30pm.</p>  <p>We offer a fun and challenging work environment with great teammates.</p>  <p>Suitably qualified and skilled candidates are encouraged to forward their resume and cover letter via the Apply for this job button below.</p>  <p>Applicants must have the legal right to work in Australia </p>  <p> </p>  <p>General Manager (Eastern States)</p><p>If you are interested in this new opportunity, please contact <strong>Amy Hatfield</strong> at Fuse Recruitment on <strong>test@example.com</strong> or <strong>0111 211 311</strong><strong> </strong>for a confidential discussion or apply now.</p>",
    contactMatches: [
      {
        type: 'Email',
        value: 'test@example.com',
        __typename: 'ContactMatches',
      },
      {
        type: 'Phone',
        value: '0111 211 311',
        __typename: 'ContactMatches',
      },
    ],
  },
  '29800254': {
    advertiser: {
      id: '20127081',
      name: 'Jobwire-Brisbane',
    },
    classification: {
      id: '1200',
      description: 'Accounting',
    },
    subClassification: {
      id: '6140',
      description: 'Accounts Officers/Clerks',
    },
    locationInfo: {
      area: 'Parramatta & Western Suburbs',
      location: 'Sydney',
      locationIds: ['18578'],
    },
    hasRoleRequirements: false,
    adProductType: 'Classic',
    title: 'Accounts Payable/Receivable Officer',
    isPrivateAdvertiser: false,
    isLinkOut: false,
    isVerified: true,
    listingDate: '25d ago',
    workType: 'Full Time',
    workTypeIds: '242',
    salary: '$55k - $60k p.a. + Super',
    status: 'Active',
    video: {
      url: 'https://www.youtube.com/embed/7ZdyRlMSmPk',
      position: 'TOP',
    },
    companyReviews: null,
    content:
      "<p>Global Industrial has been a leader in the industrial racking &amp; industrial supply industry for the last 40 years. We are currently seeking an experienced warehousing team member for a casual position at our latest Sydney warehouse based in our facility in Prestons, with a view to the position becoming permanent full time depending upon the applicant.</p>  <p> </p>  <p><strong>ESSENTIAL JOB FUNCTIONS</strong></p> <ul> <li>Daily liaison with Supervisor for jobs allocation and reporting</li> <li>Picking and packing of orders in a busy small team</li> <li>Accurate packaging of orders</li> <li>Assembly of product and some fabrication work</li> <li>A willingness to attend to general warehousing and house-keeping duties</li> <li>Experience in unloading shipping containers, however training will be provided to suitable applicants</li> <li>Proactive approach to OH&amp;S in the warehouse environment</li> <li>Other duties as required</li></ul> <p><strong>REQUIREMENTS</strong></p> <ul> <li>Previous warehousing experience</li> <li>Previous experience with racking and shelving systems would be an advantage.</li> <li>Attention to detail</li> <li>Ability to work under pressure and meet deadlines</li> <li>Current forklift license</li> <li>Mature outlook</li> <li>Excellent communication &amp; interpersonal skills</li> <li>Good time management skills</li> <li>Fresh ideas to help our organisations continued growth</li> <li>National police certificate</li> <li>Right to work in Australia</li></ul> <p> </p>  <p>This position's normal operating hours are Monday to Friday 8am to 4.30pm.</p>  <p>We offer a fun and challenging work environment with great teammates.</p>  <p>Suitably qualified and skilled candidates are encouraged to forward their resume and cover letter via the Apply for this job button below.</p>  <p>Applicants must have the legal right to work in Australia </p>  <p> </p>  <p>General Manager (Eastern States)</p><p>If you are interested in this new opportunity, please contact <strong>Amy Hatfield</strong> at Fuse Recruitment on <strong>test@example.com</strong> or <strong>0111 211 311</strong><strong> </strong>for a confidential discussion or apply now.</p>",
    contactMatches: [
      {
        type: 'Email',
        value: 'test@example.com',
        __typename: 'ContactMatches',
      },
      {
        type: 'Phone',
        value: '0111 211 311',
        __typename: 'ContactMatches',
      },
    ],
  },
  '29800253': {
    advertiser: {
      id: '33859073',
      name: 'Chandler Macleod Group',
    },
    classification: {
      id: '1212',
      description: 'Hospitality & Tourism',
    },
    subClassification: {
      id: '6055',
      description: 'Management',
    },
    locationInfo: {
      area: '',
      location: 'Geraldton, Gascoyne & Midwest',
      locationIds: ['18578'],
    },
    hasRoleRequirements: false,
    adProductType: 'Classic',
    title: 'Restaurant, manager, hospitality, retail, customer service',
    isPrivateAdvertiser: false,
    isLinkOut: false,
    isVerified: true,
    listingDate: '30d+ ago',
    workType: 'Full Time',
    workTypeIds: '242',
    salary: '$53k - $65k p.a. + Great Bonus Plan',
    status: 'Active',
    video: {
      url: 'https://www.youtube.com/embed/7ZdyRlMSmPk',
      position: 'TOP',
    },
    companyReviews: null,
    content:
      "<p>Global Industrial has been a leader in the industrial racking &amp; industrial supply industry for the last 40 years. We are currently seeking an experienced warehousing team member for a casual position at our latest Sydney warehouse based in our facility in Prestons, with a view to the position becoming permanent full time depending upon the applicant.</p>  <p> </p>  <p><strong>ESSENTIAL JOB FUNCTIONS</strong></p> <ul> <li>Daily liaison with Supervisor for jobs allocation and reporting</li> <li>Picking and packing of orders in a busy small team</li> <li>Accurate packaging of orders</li> <li>Assembly of product and some fabrication work</li> <li>A willingness to attend to general warehousing and house-keeping duties</li> <li>Experience in unloading shipping containers, however training will be provided to suitable applicants</li> <li>Proactive approach to OH&amp;S in the warehouse environment</li> <li>Other duties as required</li></ul> <p><strong>REQUIREMENTS</strong></p> <ul> <li>Previous warehousing experience</li> <li>Previous experience with racking and shelving systems would be an advantage.</li> <li>Attention to detail</li> <li>Ability to work under pressure and meet deadlines</li> <li>Current forklift license</li> <li>Mature outlook</li> <li>Excellent communication &amp; interpersonal skills</li> <li>Good time management skills</li> <li>Fresh ideas to help our organisations continued growth</li> <li>National police certificate</li> <li>Right to work in Australia</li></ul> <p> </p>  <p>This position's normal operating hours are Monday to Friday 8am to 4.30pm.</p>  <p>We offer a fun and challenging work environment with great teammates.</p>  <p>Suitably qualified and skilled candidates are encouraged to forward their resume and cover letter via the Apply for this job button below.</p>  <p>Applicants must have the legal right to work in Australia </p>  <p> </p>  <p>General Manager (Eastern States)</p><p>If you are interested in this new opportunity, please contact <strong>Amy Hatfield</strong> at Fuse Recruitment on <strong>test@example.com</strong> or <strong>0111 211 311</strong><strong> </strong>for a confidential discussion or apply now.</p>",
    contactMatches: [
      {
        type: 'Email',
        value: 'test@example.com',
        __typename: 'ContactMatches',
      },
      {
        type: 'Phone',
        value: '0111 211 311',
        __typename: 'ContactMatches',
      },
    ],
  },
  '29800255': {
    advertiser: {
      id: '33859073',
      name: 'Chandler Macleod Group',
    },
    classification: {
      id: '6058',
      description: 'Mining, Resources & Energy',
    },
    subClassification: {
      id: '6066',
      description: 'Mining - Operations',
    },
    locationInfo: {
      area: '',
      location: 'Mackay & Coalfields',
      locationIds: ['18578'],
    },
    hasRoleRequirements: false,
    adProductType: 'Classic',
    title: 'Multi-Skilled Operator with Dispatch/Mine Control Experience',
    isPrivateAdvertiser: false,
    isLinkOut: false,
    isVerified: true,
    listingDate: '30d ago',
    workType: 'Contract/Temp',
    workTypeIds: '244',
    salary: '',
    status: 'Active',
    video: {
      url: 'https://www.youtube.com/embed/7ZdyRlMSmPk',
      position: 'TOP',
    },
    companyReviews: null,
    content:
      "<p>Global Industrial has been a leader in the industrial racking &amp; industrial supply industry for the last 40 years. We are currently seeking an experienced warehousing team member for a casual position at our latest Sydney warehouse based in our facility in Prestons, with a view to the position becoming permanent full time depending upon the applicant.</p>  <p> </p>  <p><strong>ESSENTIAL JOB FUNCTIONS</strong></p> <ul> <li>Daily liaison with Supervisor for jobs allocation and reporting</li> <li>Picking and packing of orders in a busy small team</li> <li>Accurate packaging of orders</li> <li>Assembly of product and some fabrication work</li> <li>A willingness to attend to general warehousing and house-keeping duties</li> <li>Experience in unloading shipping containers, however training will be provided to suitable applicants</li> <li>Proactive approach to OH&amp;S in the warehouse environment</li> <li>Other duties as required</li></ul> <p><strong>REQUIREMENTS</strong></p> <ul> <li>Previous warehousing experience</li> <li>Previous experience with racking and shelving systems would be an advantage.</li> <li>Attention to detail</li> <li>Ability to work under pressure and meet deadlines</li> <li>Current forklift license</li> <li>Mature outlook</li> <li>Excellent communication &amp; interpersonal skills</li> <li>Good time management skills</li> <li>Fresh ideas to help our organisations continued growth</li> <li>National police certificate</li> <li>Right to work in Australia</li></ul> <p> </p>  <p>This position's normal operating hours are Monday to Friday 8am to 4.30pm.</p>  <p>We offer a fun and challenging work environment with great teammates.</p>  <p>Suitably qualified and skilled candidates are encouraged to forward their resume and cover letter via the Apply for this job button below.</p>  <p>Applicants must have the legal right to work in Australia </p>  <p> </p>  <p>General Manager (Eastern States)</p><p>If you are interested in this new opportunity, please contact <strong>Amy Hatfield</strong> at Fuse Recruitment on <strong>test@example.com</strong> or <strong>0111 211 311</strong><strong> </strong>for a confidential discussion or apply now.</p>",
    contactMatches: [
      {
        type: 'Email',
        value: 'test@example.com',
        __typename: 'ContactMatches',
      },
      {
        type: 'Phone',
        value: '0111 211 311',
        __typename: 'ContactMatches',
      },
    ],
  },
  ...minEnrichedJob,
  ...brandedJobs,
};

export const jobDetails = ({
  id,
}: {
  id: string;
}): JobDetails | JobDetailsPersonalised | null => {
  // Mock RATE_LIMITED job details response
  if (id === '999') {
    throw new MockRateLimitedGraphQLError();
  }

  // Mock non-existent job details result
  // '8888888' should trigger as Internal Server Error so it will pass the test of 'should return 500 when view job details timeout'
  if ((id === '123' || !jobDetailsMock[id]) && id !== '8888888') {
    return null;
  }

  return {
    __typename: 'JobDetails',
    personalised: {
      isSaved: jobIDsIsSaved[id] ?? false,
      appliedDateTime:
        (jobDetailsMock[id]?.appliedDateTime && {
          longAbsoluteLabel: jobDetailsMock[id].appliedDateTime,
          __typename: 'SeekDateTime',
        }) ||
        null,
      topApplicantBadge:
        (jobDetailsMock[id]?.topApplicantBadge && {
          dateTimeUtc: jobDetailsMock[id].topApplicantBadge,
          label: jobDetailsMock[id].topApplicantBadge.label,
          description: jobDetailsMock[id].topApplicantBadge.description,
          __typename: 'TopApplicantBadge',
        }) ||
        null,
      __typename: 'PersonalisedJobDetails',
    },
    job: {
      tracking: {
        adProductType: jobDetailsMock[id].adProductType,
        classificationInfo: {
          classificationId: jobDetailsMock[id].classification.id,
          classification: jobDetailsMock[id].classification.description,
          subClassificationId: jobDetailsMock[id].subClassification.id,
          subClassification: jobDetailsMock[id].subClassification.description,
          __typename: 'JobTrackingClassificationInfo',
        },
        hasRoleRequirements: jobDetailsMock[id].hasRoleRequirements,
        isPrivateAdvertiser: jobDetailsMock[id].isPrivateAdvertiser,
        locationInfo: {
          area: jobDetailsMock[id].locationInfo.area,
          location: jobDetailsMock[id].locationInfo.location,
          locationIds: jobDetailsMock[id].locationInfo.locationIds,
          __typename: 'JobTrackingLocationInfo',
        },
        workTypeIds: jobDetailsMock[id].workTypeIds,
        postedTime: jobDetailsMock[id].listingDate,
        __typename: 'JobTracking',
      },
      id,
      abstract:
        'Your chance to make a difference. A role with high responsibility. Contribute to offenders making positive changes while supporting a safer community.',
      title: jobDetailsMock[id].title,
      phoneNumber: jobDetailsMock[id].phoneNumber,
      isExpired: false,
      isLinkOut: jobDetailsMock[id].isLinkOut,
      isVerified: jobDetailsMock[id].isVerified,
      contactMatches: jobDetailsMock[id].contactMatches,
      content: jobDetailsMock[id].content,
      status: jobDetailsMock[id].status,
      listedAt: {
        label: jobDetailsMock[id].listingDate,
        __typename: 'SeekDateTime',
      },
      salary: {
        currencyLabel: jobDetailsMock[id].salaryCurrencyLabel || null,
        label: jobDetailsMock[id].salary,
        __typename: 'JobSalary',
      },
      shareLink: `https://www.seek.com.au/job/${id}?tracking=TMC-SAU-eDM-SharedJob-13246`,
      workTypes: {
        label: jobDetailsMock[id].workType,
        __typename: 'JobWorkTypes',
      },
      advertiser: {
        ...jobDetailsMock[id].advertiser,
        __typename: 'Advertiser',
      },
      location: {
        label: `${jobDetailsMock[id].locationInfo.location}${
          jobDetailsMock[id].locationInfo.area &&
          ` • ${jobDetailsMock[id].locationInfo.area}`
        }`,
        __typename: 'LocationInfo',
      },

      classifications: [
        {
          label: `${jobDetailsMock[id].subClassification.description} (${jobDetailsMock[id].classification.description})`,
          __typename: 'ClassificationInfo',
        },
        {
          label: `${jobDetailsMock['29800266'].subClassification.description} (${jobDetailsMock['29800266'].classification.description})`,
          __typename: 'ClassificationInfo',
        },
      ],
      products: {
        branding:
          (jobDetailsMock[id].branding && {
            ...jobDetailsMock[id].branding,
          }) ??
          null,
        bullets: null,
        questionnaire: {
          questions: [
            "How many years' experience do you have as a Customer Service Representative?",
            'Which of the following Microsoft Office products are you experienced with?',
          ],
          __typename: 'JobQuestionnaire',
        },
        video:
          (jobDetailsMock[id].video && {
            ...jobDetailsMock[id].video,
            __typename: 'VideoProduct',
          }) ??
          null,
        __typename: 'JobProducts',
      },
      __typename: 'Job',
    },
    learningInsights: {
      analytics: {
        'skl-lmis': 'KeywordsSearchToRole:customer-care-consultant',
        'skl-lmis-type': 'career',
      },
      content: `<style>\n  .EA097D-a * {\n    margin: 0;\n    padding: 0;\n    border: 0;\n    font: inherit;\n    vertical-align: baseline;\n    -webkit-font-smoothing: antialiased;\n  }\n\n  .EA097D-a *,\n  .EA097D-a li:before {\n    font-family: inherit;\n    box-sizing: inherit;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n    -webkit-tap-highlight-color: transparent;\n  }\n\n  .EA097D-a {\n    font-family: 'Roboto', 'Helvetica Neue', HelveticaNeue, Helvetica, Arial, sans-serif;\n    font-size: 10px;\n    box-sizing: border-box;\n    min-height: 100%;\n    position: relative;\n  }\n\n  .EA097D-b {\n    font-size: 2.1em;\n    line-height: 1.28571429em;\n    -webkit-transform: translateY(0.26285714em);\n    transform: translateY(0.26285714em);\n    color: #1c1c1c;\n    text-decoration: none;\n    display: block;\n    margin-bottom: 18px;\n  }\n\n  .EA097D-d {\n    margin-bottom: 7px;\n    list-style: none;\n  }\n\n  .EA097D-d li {\n    font-size: 1.6em;\n    line-height: 1.28571429em;\n    -webkit-transform: translateY(0.26285714em);\n    transform: translateY(0.26285714em);\n  }\n\n  .EA097D-d li {\n    color: #1c1c1c;\n    margin-bottom: 9px;\n    margin-left: 17px;\n    list-style: disc;\n  }\n\n  .EA097D-d li:last-child {\n    margin-bottom: 30px;\n  }\n\n  .EA097D-f {\n    font-size: 1.8em;\n    line-height: 45px;\n    border-radius: 2px;\n    background: #fff;\n    width: 160px;\n    color: #2765cf;\n    text-decoration: none;\n    padding: 0 14px;\n    border: 2px solid #2765cf;\n    display: block;\n    text-align: center;\n  }\n\n  .EA097D-h {\n    height: 30px;\n    width: 170px;\n    margin-bottom: 0;\n    background: url(https://cdn.seeklearning.com.au/media/images/career-guide/career-advice-blue.svg) no-repeat center;\n    background-size: contain;\n  }\n\n  @media only screen and (min-width: 580px) {\n    .EA097D-h {\n      margin-bottom: 16px;\n    }\n  }\n</style>\n\n<div class="EA097D-a">\n  <div class="EA097D-h"></div>\n  <h1>\n    <a class="EA097D-b" href="https://www.seek.com.au/career-advice/role/customer-consultant?campaigncode=lrn:skj:sklm:cg:jbd:alpha"\n      >Thinking about a career as a Customer Consultant?</a\n    >\n  </h1>\n  <ul class="EA097D-d">\n    <li>Insights on salary & in-demand skills</li>\n    <li>Reviews from people working in the industry</li>\n  </ul>\n  <a class="EA097D-f" href="https://www.seek.com.au/career-advice/role/customer-consultant?campaigncode=lrn:skj:sklm:cg:jbd:alpha">Explore career</a>\n</div>\n`,
      __typename: 'LearningInsights',
    },
    companyReviews: jobDetailsMock[id].companyReviews && {
      ...jobDetailsMock[id].companyReviews,
      __typename: 'CompanyReviews',
    },
    companySearchUrl: jobDetailsMock[id].companyReviews
      ? `http://dev.seek.com.au:8000${jobDetailsMock[id].companySearchUrl}`
      : `http://dev.seek.com.au:8000/jobs?advertiserId=${jobDetailsMock[id].advertiser.id}`,
    companyTags: jobDetailsMock[id].companyTags,
    restrictedApplication: jobDetailsMock[id].restrictedApplication || {
      label: '',
    },
    sourcr: jobDetailsMock[id].sourcr && {
      ...jobDetailsMock[id].sourcr,
      __typename: 'JobDetailsSourcr',
    },
  };
};
